import { useModal } from '../../hooks/useModal';
import Button from '../button/v2/button';
import { HButtonGroup } from '../button/v2/HButtonGroup';
import { ProfileOptionsDropdown } from '../dropdown/profile-options.dropdown';
import Avatar from '../images/avatar';
import Container from './container';

const styles = {
  container: 'relative',
  'banner-container': 'w-full relative banner overflow-hidden',
  'banner-overlay': 'w-full h-full absolute bg-black/20 z-10',
  'button-group': 'absolute top-3 mobile:right-2 tablet-lg:right-[40px] z-30',
  'avatar-container':
    'absolute bottom-[-30px]  mobile:pl-2 tablet-sm:px-7 z-20',
  'avatar-wrapper': 'mask h-fit w-fit mask-squircle p-1 bg-[#121212]',
  'summary-container':
    'absolute right-0 bottom-[-45px] mobile:pr-0 tablet-sm:pr-7 z-10',
};

// just load the content for the banner inside of itself

type BannerContainerProps = {
  bannerUrl: string;
  avatarUrl: string;
  username: string;
  displayName: string;
  variant: 'artist' | 'owned';
  collections: string;
  sales: string;
  trackers: string;
  tracking: string;
};

export default function BannerContainer(props: BannerContainerProps) {
  const [openEditProfileModal] = useModal('EDIT_PROFILE');

  const bgImageStyles = {
    backgroundImage: `url(${props.bannerUrl})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  };

  return (
    <Container extensions={styles.container}>
      <div style={bgImageStyles} className={styles['banner-container']}>
        <Container extensions={styles['banner-overlay']} />
        <HButtonGroup extensions={styles['button-group']}>
          {props.variant === 'owned' && (
            <Button onClick={openEditProfileModal} size="sm" variant="outline">
              Edit Profile
            </Button>
          )}
          {props.variant === 'artist' && (
            <ProfileOptionsDropdown username={props.username} />
          )}
        </HButtonGroup>
      </div>
      <Container extensions={styles['avatar-container']}>
        <Container extensions={styles['avatar-wrapper']}>
          <Avatar
            url={props.avatarUrl}
            alt={`${props.username} profile`}
            size="lg"
          />
        </Container>
      </Container>
    </Container>
  );
}
